<template>
	<div class="spinner" :class="{ 'spinner--banner': isBanner }">
		<div class="spinner__item">
			<div class="spinner__item">
				<div class="spinner__item">
					<div class="spinner__item">
						<div class="spinner__item">
							<div class="spinner__item" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Spinner',
	props: {
		isBanner: {
			type: Boolean,
			default: false
		}
	}
};
</script>
